import { ChangeUpdateApplicantsTypes } from "../../ActionTypes/changeUpdateApplicantsTypes ";
import { ChangeUpdateApplicantsActions, ChangeUpdateApplicantsState } from "../../types/type";



const initialState: ChangeUpdateApplicantsState = {
  pending: false,
  applicant: [],
  error: null,
};

export default (state = initialState, action: ChangeUpdateApplicantsActions,) => {
  switch (action.type) {
    case ChangeUpdateApplicantsTypes.FETCH_CHANGE_UPDATE_APPLICANTS_REQUEST:
      return {
        ...state,
        pending: false
      };
    case ChangeUpdateApplicantsTypes.FETCH_CHANGE_UPDATE_APPLICANTS_SUCCESS:
      return {
        ...state,
        pending: true,
        applicant: action.payload.applicant,
        error: null
      };
    case ChangeUpdateApplicantsTypes.FETCH_CHANGE_UPDATE_APPLICANTS_FAILURE:
      return {
        ...state,
        pending: false,
        applicant: [],
        error: action.payload.error
      };
    default:
      return {
        ...state
      };
  }
};
